import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-78df272d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  alt: "Booster",
  src: _imports_0
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["booster-nav pt-3 pb-3 d-flex align-items-center justify-content-center", _ctx.isMobileScreen ? 'ps-3': 'ps-5'])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["nav-width", {'ps-4': !_ctx.isMobileScreen && !_ctx.isMediumScreen, 'wide-screen': _ctx.isWiderScreen, 'ms-4': _ctx.isLargeScreen}])
    }, _hoisted_2, 2)
  ], 2))
}